export const visit = (vm, at) => {
at({ "en": { "conversations-thread-view": { "filtered-threads": { "mark-as-spam-prompt": { "body": "You're about to mark this item as spam which will move it to your 'Spam' view. Are you sure?", "cancel": "Cancel", "confirm": "Mark as spam", "header": "Mark as spam" } } } } });
};